import React from 'react';
import { useStripeCustomerPortalService } from 'nekst-api';
import { ButtonSize, OptionSelectionButton } from 'ui-builder';
import { useUpdateSubscriptionPlanForm } from './UpdateSubscriptionPlanForm';
import { useBillingContext } from './BillingPageContext';
import useFeatureToggleService from 'feature-toggle';

export function useStripePortalNavigator() {
  const stripeCustomerPortal = useStripeCustomerPortalService();

  return {
    navigateToUpdateSubscription: async () => {
      window.location.href = await stripeCustomerPortal.createUpdateSubscriptionLink();
    },
    navigateToUpdatePaymentMethod: async () => {
      window.location.href = await stripeCustomerPortal.createUpdatePaymentMethodLink();
    },
    navigateToBillingInformation: async () => {
      window.location.href = await stripeCustomerPortal.createPortalAccessLink();
    }
  };
}

export default function ManageSubscriptionOptionsButton() {
  const stripeCustomerPortal = useStripeCustomerPortalService();

  const formHelper = useUpdateSubscriptionPlanForm();

  const billingContext = useBillingContext();
  const billingData = billingContext.getData();
  const featureToggleService = useFeatureToggleService();

  const hasActiveLockIn = featureToggleService.isLockInBannerEnabled()
    && !!billingData.teamBilling.lockInExpiresAt
    && billingData.teamBilling.lockInExpiresAt > new Date();

  return (
    <OptionSelectionButton
      text="Manage Subscription"
      options={[
        !hasActiveLockIn && {
          value: 'update-subscription',
          label: 'Update Subscription Plan',
          onSelected: async () => {
            if (billingData.teamBilling.isAiLauncherEnabled) {
              window.location.href = await stripeCustomerPortal.createUpdateSubscriptionLink();
            } else {
              formHelper.openForm();
            }
          }
        },
        {
          value: 'update-payment-method',
          label: 'Update Payment Method',
          onSelected: async () => {
            window.location.href = await stripeCustomerPortal.createUpdatePaymentMethodLink();
          }
        },
        {
          value: 'access-portal',
          label: 'View Billing Information',
          onSelected: async () => {
            window.location.href = await stripeCustomerPortal.createPortalAccessLink();
          }
        }
      ]}
      size={ButtonSize.MEDIUM}
    />
  );
}
